/* ==========================================================================
   LANDOT — site-wide widgets
   1. Email subscribe popup (shows once per session, ~4s after load)
   2. Floating customer-service chat button + edge chat panel
   Self-injects all DOM; styles live in theme.css (.au-* classes)
   ========================================================================== */
(function () {
  'use strict';

  /* Storage access throws in private mode / when cookies are blocked */
  function storeGet(store, key) {
    try { return window[store].getItem(key); } catch (err) { return null; }
  }
  function storeSet(store, key, value) {
    try { window[store].setItem(key, value); } catch (err) { /* no-op */ }
  }

  /* Escapes text before it is concatenated into an innerHTML string.
     Shared by the popup and the chat window, both of which now interpolate
     values that come from the theme settings. */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Locale/market aware root, e.g. "/" or "/en-gb/" */
  function routeRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (window.theme && window.theme.routes && window.theme.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  /* Do NOT call window.Shopify.captcha.protect() on this form.
     That API force-attaches a captcha to a form. The shop has captcha switched
     off for contact forms in the admin (Online Store > Preferences > Spam
     protection), and calling protect() puts it straight back — shoppers then get
     an image puzzle they can't get past and nobody can subscribe. If a captcha is
     ever wanted here, turn it on in the admin instead of forcing it from code. */

  /* ------------------------------ Subscribe popup ------------------------------ */
  function initSubscribePopup() {
    var cfg = window.AU_POPUP_CONFIG || {};
    if (cfg.enabled === false) return;
    if (storeGet('localStorage', 'au_subscribed_v2')) return;
    if (storeGet('sessionStorage', 'au_popup_shown_v2')) return;
    var dismissedUntil = parseInt(storeGet('localStorage', 'au_popup_dismissed_until_v2'), 10);
    if (dismissedUntil && Date.now() < dismissedUntil) return;

    /* Never interrupt a shopper who is already buying: product, cart, checkout, account.
       Verified in-browser: the popup plus the cookie banner together cover the
       Add to Bag button, forcing two dismissals before a purchase is possible.
       Which templates to skip is merchant-configurable (skipTemplates); the list
       below is the fallback when that setting is empty. */
    var skipList = (typeof cfg.skipTemplates === 'string' && cfg.skipTemplates)
      ? cfg.skipTemplates.split(',')
      : ['product', 'cart', 'checkout', 'customers'];
    /* The body carries more than one marker (template-page AND
       template-page-contact), so every one of them has to be tested. */
    var tpls = document.body.className.match(/template-[a-z0-9_-]+/gi) || [];
    for (var si = 0; si < skipList.length; si++) {
      var skip = String(skipList[si]).trim().toLowerCase();
      if (!skip) continue;
      for (var ti = 0; ti < tpls.length; ti++) {
        if (tpls[ti].toLowerCase().slice('template-'.length).indexOf(skip) === 0) return;
      }
    }

    var image = cfg.image || '';
    var perks = [cfg.perk1, cfg.perk2, cfg.perk3].filter(function (p) { return p; });
    var privacyUrl = cfg.privacyUrl || '';

    var overlay = document.createElement('div');
    overlay.className = 'au-popup-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<div class="au-popup" role="dialog" aria-modal="true" aria-labelledby="au-popup-title"' +
          (image ? '' : ' style="grid-template-columns:1fr;max-width:460px;"') + '>' +
        '<button type="button" class="au-popup__close" aria-label="Close popup">&times;</button>' +
        (image
          ? '<div class="au-popup__media">' +
              '<img src="' + esc(image) + '" alt="">' +
              '<span class="au-popup__badge">' + esc(cfg.badge || 'JOIN US') + '</span>' +
            '</div>'
          : '') +
        '<div class="au-popup__body">' +
          '<p class="au-popup__eyebrow">' + esc(cfg.eyebrow || 'Welcome to LANDOT') + '</p>' +
          '<h3 class="au-popup__title" id="au-popup-title">' + esc(cfg.heading || 'Join the LANDOT list') + '</h3>' +
          '<p class="au-popup__text">' + esc(cfg.text || 'Styling tips from professionals, and first word on new tools.') + '</p>' +
          '<ul class="au-popup__perks">' +
            perks.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') +
          '</ul>' +
          /* A real form that the browser submits itself. The previous version
             posted with fetch() in the background, and the shop's bot protection
             answers those with a 403 "Verifying your connection" page — so every
             shopper saw "we could not sign you up". A native submit carries the
             same signals a normal page navigation does and passes. */
          /* action must carry the #contact_form fragment and the form the matching id —
             that pair is how Shopify's contact endpoint identifies a newsletter post.
             Without it the POST lands but is never recorded, which is why the popup
             kept reporting failure while the footer form worked. */
          /* This shop enforces Shopify's storefront captcha server-side: a post
             without a token comes back 400 "Missing CAPTCHA token". So the form
             must be one Shopify's bootstrap recognises AND can mount a widget
             into — which means it has to exist in the document when that script
             runs, not be injected by us afterwards. */
          '<form class="au-popup__form" method="post" action="' + esc(routeRoot()) + 'contact" accept-charset="UTF-8" novalidate>' +
            '<input type="hidden" name="form_type" value="customer">' +
            '<input type="hidden" name="utf8" value="\u2713">' +
            '<input type="hidden" name="contact[tags]" value="newsletter">' +
            '<input type="email" name="contact[email]" class="au-popup__input" placeholder="' + esc(cfg.placeholder || 'Enter your email') + '" required>' +
            '<button type="button" class="button" data-au-subscribe>' + esc(cfg.buttonLabel || 'Subscribe') + '</button>' +
          '</form>' +
          '<p class="au-popup__consent" style="font-size:12px;line-height:1.5;opacity:.7;margin:10px 0 0;">' +
            esc(cfg.consentText || 'By subscribing you agree to receive marketing emails from LANDOT. You can unsubscribe at any time.') +
            (privacyUrl
              ? ' <a href="' + esc(privacyUrl) + '" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;">' + esc(cfg.privacyLabel || 'Privacy Policy') + '</a>'
              : '') +
          '</p>' +
          '<p class="au-popup__error" role="alert" style="display:none;font-size:13px;color:#c0392b;margin:10px 0 0;">' + esc(cfg.errorMessage || 'Sorry, we could not sign you up just now. Please try again.') + '</p>' +
          '<button type="button" class="au-popup__dismiss">' + esc(cfg.dismissLabel || 'No thanks') + '</button>' +
          '<p class="au-popup__success" role="status">' + esc(cfg.successMessage || "You're on the list. Watch your inbox.") + '</p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    var dialog = overlay.querySelector('.au-popup');
    var form = overlay.querySelector('.au-popup__form');
    var input = overlay.querySelector('.au-popup__input');
    var success = overlay.querySelector('.au-popup__success');
    var errorEl = overlay.querySelector('.au-popup__error');
    var submitBtn = form.querySelector('[data-au-subscribe]');
    var closeBtn = overlay.querySelector('.au-popup__close');
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      storeSet('sessionStorage', 'au_popup_shown_v2', '1');
      /* theme.css puts a 0.3s transition on the overlay's visibility, so the dialog
         is still visibility:hidden on this frame and focus() would silently fail.
         Two frames later it is visible and the focus trap actually takes over. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          closeBtn.focus();
        });
      });
    }
    function close() {
      if (!overlay.classList.contains('is-open')) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var days = parseInt(cfg.dismissDays, 10) || 30;
      storeSet('localStorage', 'au_popup_dismissed_until_v2', String(Date.now() + days * 86400000));
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    closeBtn.addEventListener('click', function () { close(); });
    overlay.querySelector('.au-popup__dismiss').addEventListener('click', function () { close(); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* Keep Tab inside the dialog while it is open */
    overlay.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(
        dialog.querySelectorAll('button, a[href], input, select, textarea'),
        function (el) { return !el.disabled && el.offsetParent !== null; }
      );
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    function showSuccess() {
      form.style.display = 'none';
      overlay.querySelector('.au-popup__dismiss').style.display = 'none';
      var perksEl = overlay.querySelector('.au-popup__perks');
      if (perksEl) perksEl.style.display = 'none';
      var consentEl = overlay.querySelector('.au-popup__consent');
      if (consentEl) consentEl.style.display = 'none';
      success.classList.add('is-visible');
      storeSet('localStorage', 'au_subscribed_v2', '1');
      setTimeout(close, 2600);
    }
    function showFailure(err) {
      if (err) console.warn('[widgets] subscribe failed:', err);
      if (submitBtn) submitBtn.disabled = false;
      errorEl.style.display = 'block';
      input.classList.add('is-error');
      input.focus();
    }

    /* Posts the form without navigating away.

       A plain form submit hands the browser to Shopify, which — when its bot
       check is unhappy — 302s to /challenge. That page was removed in October
       2024 and now returns 404, so the shopper lands on a dead page and never
       sees any confirmation. Posting in the background keeps them here and lets
       us show the result ourselves, whatever Shopify answers. */
    function postSignup(email) {
      /* Take the fields straight off the form rather than hand-rolling them:
         Shopify rejects the post with "invalid parameters" if anything it put
         there is missing, and the set of hidden fields is its business, not ours. */
      var body = new URLSearchParams();
      for (var i = 0; i < form.elements.length; i++) {
        var el = form.elements[i];
        if (!el.name) continue;
        if (el.type === 'checkbox' && !el.checked) continue;
        body.set(el.name, el.name === 'contact[email]' ? email : el.value);
      }
      return fetch(form.action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'text/html' },
        body: body.toString(),
        redirect: 'follow',
        credentials: 'same-origin'
      }).then(function (res) {
        var landed = res.url || '';
        if (res.status === 403) {
          /* Shopify's bot check ("Verifying your connection"). Retrying in a
             moment usually clears it; it is not something the shopper did. */
          throw new Error('challenge');
        }
        if (landed.indexOf('/challenge') !== -1) {
          /* Shopify's bot check kicked in. Nothing the shopper can do here —
             the page it wants to show them no longer exists. */
          throw new Error('challenge');
        }
        if (landed.indexOf('customer_posted=true') !== -1) return true;
        if (!res.ok) throw new Error('http ' + res.status);
        return res.text().then(function (html) {
          if (html.indexOf('customer_posted=true') !== -1) return true;
          throw new Error('not confirmed');
        });
      });
    }

    function trySubscribe() {
      var val = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
        input.classList.add('is-error');
        input.focus();
        return;
      }
      input.classList.remove('is-error');
      errorEl.style.display = 'none';
      if (submitBtn) { submitBtn.disabled = true; }
      postSignup(val).then(function () {
        showSuccess();
      }).catch(function (err) {
        if (submitBtn) submitBtn.disabled = false;
        errorEl.textContent = (err && err.message === 'challenge')
          ? (cfg.blockedMessage || 'We could not verify that request. Please try again in a moment.')
          : (cfg.errorMessage || 'Sorry, we could not sign you up just now. Please try again.');
        errorEl.style.display = 'block';
        input.focus();
      });
    }

    if (submitBtn) submitBtn.addEventListener('click', trySubscribe);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); trySubscribe(); }
    });
    /* The form element stays for semantics, but never navigates: a real submit
       hands control to Shopify, which 302s to /challenge — a page Shopify
       removed in October 2024 that now 404s, leaving the shopper on a dead page
       with no confirmation. */
    form.addEventListener('submit', function (e) { e.preventDefault(); });

    input.addEventListener('input', function () { input.classList.remove('is-error'); });

    /* Four seconds put this panel over the hero shot before a shopper had seen
       what the shop sells — the first thing on screen was a request for their
       email. Waiting for them to scroll past the first screen means it only
       appears to someone already browsing, and the timer stays as a fallback
       for a visitor who reads without scrolling. Whichever comes first wins,
       and both are disarmed on the way in so it can never open twice. */
    var armed = true;

    function trigger() {
      if (!armed) return;
      armed = false;
      window.removeEventListener('scroll', onScroll);
      setTimeout(open, 800);
    }

    function onScroll() {
      if (window.pageYOffset > window.innerHeight * 0.9) trigger();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(trigger, (parseInt(cfg.delay, 10) || 30) * 1000);
  }

  /* -------------------------------- Chat widget -------------------------------- */
  function initChat() {
    /* The customer-service address was typed out five separate times below, so a
       change had to be made in five places or the widget would send shoppers to a
       dead address. One value now, supplied by theme.liquid (window.AU_CHAT_CONFIG)
       and falling back to the address the widget shipped with. */
    var chatCfg = window.AU_CHAT_CONFIG || {};
    var supportEmail = chatCfg.supportEmail || 'hello@landot.com';

    var wrap = document.createElement('div');
    wrap.className = 'au-chat';
    wrap.innerHTML =
      '<button type="button" class="au-chat__toggle" aria-label="Chat with customer service"' +
        ' aria-expanded="false" aria-controls="au-chat-panel">' +
        '<svg class="au-chat__icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>' +
        '</svg>' +
        '<svg class="au-chat__icon-close" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<div class="au-chat__panel" id="au-chat-panel" role="dialog" aria-labelledby="au-chat-name" aria-hidden="true">' +
        '<div class="au-chat__header">' +
          '<div class="au-chat__header-info">' +
            '<span class="au-chat__name" id="au-chat-name">LANDOT Quick Answers</span>' +
            '<span class="au-chat__status"><span class="au-chat__dot"></span>Automated help &mdash; not a live agent</span>' +
          '</div>' +
          '<button type="button" class="au-chat__close" aria-label="Close chat">&times;</button>' +
        '</div>' +
        '<div class="au-chat__messages" aria-live="polite">' +
          '<div class="au-chat__msg au-chat__msg--bot">Hi! This is LANDOT\'s automated help window. It answers a few common questions instantly &mdash; messages here are not sent to our team. To reach a person, email ' + esc(supportEmail) + '.</div>' +
          '<div class="au-chat__chips">' +
            '<button type="button" data-q="Product advice">Product advice</button>' +
            '<button type="button" data-q="Track my order">Track my order</button>' +
            '<button type="button" data-q="Shipping & returns">Shipping &amp; returns</button>' +
          '</div>' +
        '</div>' +
        '<form class="au-chat__form">' +
          '<input type="text" class="au-chat__input" placeholder="Type a message..." autocomplete="off">' +
          '<button type="submit" class="au-chat__send" aria-label="Send message">&rarr;</button>' +
        '</form>' +
      '</div>';
    document.body.appendChild(wrap);

    var toggle = wrap.querySelector('.au-chat__toggle');
    var panel = wrap.querySelector('.au-chat__panel');
    var closeBtn = wrap.querySelector('.au-chat__close');
    var messages = wrap.querySelector('.au-chat__messages');
    var form = wrap.querySelector('.au-chat__form');
    var input = wrap.querySelector('.au-chat__input');

    function openPanel() {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.classList.add('is-active');
      /* theme.css animates the panel from visibility:hidden, so focus only lands
         once it is actually visible — and only if it is still open by then. */
      setTimeout(function () {
        if (panel.classList.contains('is-open')) input.focus();
      }, 200);
    }
    function closePanel(returnFocus) {
      if (!panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('is-active');
      /* Keyboard users must not be dumped back at the top of the page. */
      if (returnFocus !== false) toggle.focus();
    }

    toggle.addEventListener('click', function () {
      panel.classList.contains('is-open') ? closePanel(false) : openPanel();
    });
    closeBtn.addEventListener('click', function () { closePanel(); });
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });

    function botReplyFor(text) {
      var t = text.toLowerCase();
      if (/track|order|delivery|where is/.test(t)) {
        return 'This window cannot look up orders. Please email ' + supportEmail + ' with your order number and our team will reply with your tracking details.';
      }
      if (/ship|return|refund|exchange/.test(t)) {
        return 'Our current shipping, returns and refund terms are set out on the policy pages linked at the bottom of every page \u2014 those pages always take precedence. For anything specific, email ' + supportEmail + '.';
      }
      if (/advice|recommend|which|product|curl|straight|iron|dryer|wand|hair type/.test(t)) {
        return 'Our 60-second Hair Quiz gives instant recommendations based on your hair type and the look you want. For a personal recommendation, email ' + supportEmail + ' with your hair type and we\'ll come back to you.';
      }
      if (/hi|hello|hey|price|cost|discount|sale/.test(t)) {
        return 'Hello! New here? Subscribe to our list for First word on new tools. Product details and prices are on each product page.';
      }
      return 'Thanks for your message! This window only answers a few common questions and does not send your message to us. Please email ' + supportEmail + ' and our team will pick it up from there.';
    }

    function addMsg(text, who) {
      var el = document.createElement('div');
      el.className = 'au-chat__msg au-chat__msg--' + who;
      el.textContent = text;
      messages.appendChild(el);
      messages.scrollTop = messages.scrollHeight;
      return el;
    }

    function send(text) {
      text = (text || '').trim();
      if (!text) return;
      addMsg(text, 'user');
      input.value = '';

      var typing = document.createElement('div');
      typing.className = 'au-chat__msg au-chat__msg--bot au-chat__typing';
      typing.innerHTML = '<span></span><span></span><span></span>';
      messages.appendChild(typing);
      messages.scrollTop = messages.scrollHeight;

      setTimeout(function () {
        typing.remove();
        addMsg(botReplyFor(text), 'bot');
      }, 900);
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); send(input.value); });
    messages.addEventListener('click', function (e) {
      var chip = e.target.closest('.au-chat__chips button');
      if (chip) send(chip.getAttribute('data-q'));
    });
  }

  function initFeaturedCollection() {
    var grids = document.querySelectorAll('[data-fc-grid]');
    grids.forEach(function(grid) {
      /* The home page stacks several Featured Collection sections. A document-wide
         lookup handed every grid the FIRST section's arrows, so the top row moved
         no matter which arrows were clicked and the lower rows never scrolled.
         Scope the buttons to the section the grid actually lives in. */
      var scope = (grid.closest && grid.closest('.featured-collection')) || grid.parentNode || document;
      var prevBtn = scope.querySelector('[data-fc-prev]');
      var nextBtn = scope.querySelector('[data-fc-next]');
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          var card = grid.querySelector('.product-card');
          var step = card ? card.offsetWidth + 24 : grid.clientWidth;
          grid.scrollBy({ left: -step, behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          var card = grid.querySelector('.product-card');
          var step = card ? card.offsetWidth + 24 : grid.clientWidth;
          grid.scrollBy({ left: step, behavior: 'smooth' });
        });
      }
      function updateButtons() {
        if (prevBtn) prevBtn.disabled = grid.scrollLeft <= 4;
        if (nextBtn) nextBtn.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4;
      }
      grid.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      setTimeout(updateButtons, 100);

      // Mouse wheel horizontal scroll
      grid.addEventListener('wheel', function(e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          grid.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      }, { passive: false });
    });
  }

  /* Opening/closing the drawer (and the body scroll lock) is owned by
     theme.js initMobileDrawer(); only the in-drawer accordions live here. */
  function initMobileDrawerAccordions() {
    var drawer = document.querySelector('.mobile-drawer');
    if (!drawer) return;

    /* `parent` used to be dereferenced straight away: a trigger that is ever moved
       out of its wrapper threw a TypeError here and killed every listener bound
       after it. Bail out loudly instead of taking the whole menu down with it. */
    function bindAccordion(trigger, wrapperSelector) {
      var parent = trigger.closest(wrapperSelector);
      if (!parent) {
        console.warn('[widgets] accordion trigger has no ' + wrapperSelector + ' wrapper:', trigger);
        return;
      }
      trigger.setAttribute('aria-expanded', parent.classList.contains('is-open') ? 'true' : 'false');
      trigger.addEventListener('click', function() {
        var isOpen = parent.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    // Top-level accordions
    var triggers = drawer.querySelectorAll('[data-accordion-trigger]');
    triggers.forEach(function(t) { bindAccordion(t, '.mobile-drawer__accordion'); });

    // Sub-accordions
    var subTriggers = drawer.querySelectorAll('[data-subaccordion-trigger]');
    subTriggers.forEach(function(t) { bindAccordion(t, '.mobile-drawer__subaccordion'); });
  }

  function boot() {
    initSubscribePopup();
    initChat();
    initFeaturedCollection();
    initMobileDrawerAccordions();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
